/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import DatePicker from '../../../../date-picker'
//import {getYear} from '../../../../../utils/date.utils'
import { CustomDateInput } from '../customDate'
import { useSmartFormContext } from '../../../../../context/smart-form.context'
import { smartFormConst } from '../../../../../utils/action.constant'
import { loadFinalValue, arithmaticCalcu } from '../../../../../utils/form.util'
import { toSnakeCase } from '../../../../../utils/common.util'
import { format } from 'date-fns'

/**
 * dataTypeId 3
 * dataTypeName Date
 */

const PastDateField = ({
	field,
	isRequired,
	onValidate,
	isDisabled = true,
	fieldIndex,
	fieldList,
	scrollToBottom = () => {},
}) => {
	const {
		state: { fields: formFields, toReFreshNumVal },
		dispatch,
	} = useSmartFormContext()
	const fields = !!formFields[field.form_id] ? formFields[field.form_id] : {}

	const onChange = value => {
		let formattedDate = format(new Date(value), 'yyyy-MM-dd')
		if (!!isRequired) {
			if (!!value) {
				onValidate(true)
			} else {
				onValidate(false)
			}
		} else {
			onValidate(true)
		}
		dispatch({
			type: smartFormConst.SET_FIELD_VALUE,
			fieldId: field.field_id,
			formId: field.form_id,
			value: loadFinalValue(field, formattedDate),
		})
		dispatch({
			type: smartFormConst.TO_REFRESH_NUM_VAL,
		})
	}

	let value = !!fields[field.field_id] ? fields[field.field_id].field_value : ''

	useEffect(() => {
		if (!!fields[field.field_id] && fields[field.field_id].field_value) {
			onChange(fields[field.field_id].field_value)
		}
	}, [value])

	useEffect(() => {
		if (
			!!field?.field_inline_data?.formula?.length &&
			!!formFields[field.form_id]
		) {
			dispatch({
				type: smartFormConst.SET_FIELD_VALUE,
				fieldId: field.field_id,
				formId: field.form_id,
				value: loadFinalValue(
					field,
					arithmaticCalcu(
						field,
						formFields[field.form_id],
						fieldList
					).toString()
				),
			})
			onValidate(true)
		}
	}, [toReFreshNumVal])

	let minDate = ''
	let excludeRange =
		field?.field_inline_data?.field_date_range_enabled &&
		field?.field_inline_data?.range_setting?.exclude_range
			? field.field_inline_data.range_setting.exclude_range
			: 0

	if (
		field?.field_inline_data?.field_date_range_enabled &&
		field?.field_inline_data?.range_setting?.flag_past_range_enabled
	) {
		let now = new Date()
		let newDate = ''
		const value = field?.field_inline_data?.range_setting
			?.field_past_date_range_value
			? field.field_inline_data.range_setting.field_past_date_range_value
			: 0

		if (field?.field_inline_data?.range_setting?.selected_range === 'Years') {
			let months = 12 * value

			for (var i = 1; i < months + 1; i++) {
				newDate = new Date(now.getFullYear(), now.getMonth() - i, now.getDate())
			}
			if (newDate) {
				minDate = new Date(
					newDate.getFullYear(),
					newDate.getMonth(),
					newDate.getDate()
				)
			}
		} else if (
			field?.field_inline_data?.range_setting?.selected_range === 'Months'
		) {
			for (var j = 1; j < value + 1; j++) {
				newDate = new Date(now.getFullYear(), now.getMonth() - j, now.getDate())
			}
			if (newDate) {
				minDate = new Date(
					newDate.getFullYear(),
					newDate.getMonth(),
					newDate.getDate()
				)
			}
		} else {
			for (var k = 1; k < value + 1; k++) {
				newDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - k)
			}
			if (newDate) {
				minDate = new Date(
					newDate.getFullYear(),
					newDate.getMonth(),
					newDate.getDate()
				)
			}
		}
	}

	return (
		<DatePicker
			className={`past-date-field-${toSnakeCase(field.field_name)}  ${
				fields[field.field_id]
					? new Date(fields[field.field_id].field_value)
					: new Date()
			}`}
			dateFormat='dd/MM/yyyy'
			customInput={<CustomDateInput field={field} isDisabled={isDisabled} />}
			id={`${field.field_name.split(' ').join('-')}`}
			maxDate={!!excludeRange ? (minDate ? minDate : '') : new Date()}
			minDate={!!excludeRange ? '' : minDate ? minDate : ''}
			showPopperArrow={true}
			selectedDate={!!value ? (value === 'null' ? '' : new Date(value)) : ''}
			onChange={onChange}
			disabled={isDisabled}
			onFocus={e => scrollToBottom('select-scroll')}
			// popperPlacement={fieldIndex > 2 ? 'top-start' : 'bottom-start'}
		/>
	)
}

export default PastDateField
